import BaseService from './base.service';

export default class ReservationService extends BaseService {
    static ENDPOINT = '/reservations';

    static async createReservation(orgId, data) {
        return this.post(`${this.ENDPOINT}/org/${orgId}`, data);
    }

    static async importReservations(orgId, reservations) {
        return this.post(`${this.ENDPOINT}/org/${orgId}/import`, { reservations });
    }
}
